<template>
  <div id="app">

    <el-container style="height: 100vh;">
      <!-- <el-aside width="200px" style="background-color: rgb(238, 241, 246);"> -->
      <!-- <el-aside v-if="WidthIsHidden" width="200px" style="background-color: #fff;"> -->
      <el-aside v-if="WidthIsHidden" width="200px" style="">
        <el-menu class="el-menu-vertical-demo" style="" @select="handleSelect">
          
          <!-- <div style="text-align: center;"><el-button type="danger" @click="goTo('/')">logo</el-button></div> -->
          <div style="text-align: center;padding: 10px 0 50px 0;">
            <a href="/"><img width="150px" src="@/assets/logo.png" fit="contain"></a>
          </div>

          <!-- 人气搜索顺序 -->
          <el-menu-item index="92">
            <i class="el-icon-medal-1 el-menu-item-li"></i>
            <!-- <span slot="title" class="menu-font item_span">인기검색순</span> -->
            <span slot="title" class="menu-font item_span" style="color: #ffff00;">인기검색순</span>
          </el-menu-item>
          <!-- 电影 -->
          <el-menu-item index="1">
            <i class="el-icon-s-ticket el-menu-item-li"></i>
            <!-- <span slot="title" class="menu-font item_span">영화</span> -->
            <span slot="title" class="menu-font item_span" style="color: #ffff00;">영화</span>
          </el-menu-item>
          <!-- 电视剧 -->
          <el-menu-item index="2" route="AboutView">
            <i class="el-icon-video-camera-solid el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;">드라마</span>
          </el-menu-item>
          <!-- 综艺/娱乐 -->
          <el-menu-item index="3">
            <i class="el-icon-s-flag el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;">예능</span>
          </el-menu-item>
          <!-- 综艺/娱乐 -->
          <el-menu-item index="4">
            <i class="el-icon-s-opportunity el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;">시사</span>
          </el-menu-item>
          <!-- 时事/教养 -->
          <el-menu-item index="5">
            <i class="el-icon-bicycle el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;">애니메이션</span>
          </el-menu-item>
          <!-- YouTube综艺 -->
          <el-menu-item index="6">
            <i class="el-icon-hot-water el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;">OTT예능</span>
          </el-menu-item>
          <!-- 完结的电视剧 -->
          <el-menu-item index="9">
            <i class="el-icon-guide el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;">지난드라마</span>
          </el-menu-item>
          <!-- 最新更新 -->
          <el-menu-item index="91">
            <i class="el-icon-upload el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span">최신업데이트<el-badge v-if="GetInfo.today_count>0" :value="GetInfo.today_count" style="top:-15px;"></el-badge></span>
          </el-menu-item>
          <!-- 友情链接 -->
          <el-menu-item index="93">
            <i class="el-icon-link el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span">링크동맹</span>
          </el-menu-item>

          <el-menu-item index="100">
            <!-- <i class="el-icon-present"></i> -->
            <span slot="title" class="menu-font item_span" style="color: #ff0000;">🔞&nbsp;성인</span>
          </el-menu-item>
          <el-menu-item index="101">
            <i class="el-icon-present"></i>
            <span slot="title" class="menu-font item_span" style="color: #ff0000;">코믹툰툰</span>
          </el-menu-item>
          <!-- <el-menu-item index="101">
            <span slot="title" class="menu-font item_span" style="color: #ff0000;">⚽︎&nbsp;월드컵 경기분석</span>
          </el-menu-item> -->
          
          <!-- 广告 -->
          <!-- <el-menu-item index="100">
            <img src="@/assets/tablet.png" style="filter:brightness(0);opacity: 50%;width: 18px;height: 18px;margin: 0 10px 0 0;">
            <span slot="title" class="menu-font">비아그라</span>
          </el-menu-item> -->

        </el-menu>
      </el-aside>


      <el-main style="overflow-y: scroll;padding: 0;"><!--- rgb(247, 248, 249) ---> <!-- background-color: #fff; -->
        
        <div>
          <!-- PC顶部 -->
          <TopSearch v-if="WidthIsHidden" :link="GetInfo.link" :screenWidth="screenWidth" :topkeys="GetInfo.topkeys" :gridData="gridData" style="position: sticky; top:0px;z-index: 99; "></TopSearch>
          <!-- PC顶部 -->

          <!-- 手机顶部 -->
          <TopSearch_m v-if="!WidthIsHidden" @showTopMenu="showTopMenu" @showTopSearch="showTopSearch" style="position: sticky; top:0px;z-index: 99; "></TopSearch_m>
          <!-- 手机顶部 -->
        </div>

        <router-view></router-view>

        <div class="crft">
          <el-row :span="24">
            <el-col class="rol" :span="24" style="color: rgb(162, 162, 162);font-size: 11pt;">
              <!-- 고객센터 이용약관 개인정보처리방침 청소년 보호정책 법적고지 이벤트 인재채용 -->

              <!-- <div class="foot_router" v-for="(item,index) in GetInfo.article" :key="index">
                <a v-if="item.url!==''&&item.txt==''" target="_blank" :href="item.url">{{ item.title }}</a>
                <a v-else :href="'PageView?id='+item.id">{{ item.title }}</a>
              </div> -->
            </el-col>
            <el-col class="rol" :span="24">
              대표이사 : 심수련사업자정보확인사업자등록번호 : 188-45-35157 | 통신판매신고번호 : 2020-서울마포-2567호
            </el-col>
            <el-col class="rol" :span="24">
              사업장 : 서울특별시 마포구 상암산로 34
            </el-col>
            <el-col class="rol" :span="24">
              고객센터 (평일 09시~17시/점심시간 13시~14시)1:1 게시판 문의
            </el-col>
            <el-col class="rol" :span="24">
              <div class="foot_img" v-for="(item,index) in GetInfo.img" :key="index">
                <a :href="item.url" target="_blank"><img :src="item.img" width="100" :alt="item.title"></a>
              </div>
            </el-col>
            <el-col class="rol" :span="24">
              Copyright © 골드티비 All right reserved.
            </el-col>
            <el-col class="rol" :span="24">
              <div v-for="(item,index) in GetInfo.hidelink" :key="index">
                <a :href="item.url" target="_blank">{{ item.title }}</a>
              </div>
            </el-col>
            
          </el-row>
        </div>

        <div style="height: 35px;" v-if="!WidthIsHidden"></div>

      </el-main>
      
    </el-container>

    <FootNav v-if="!WidthIsHidden" />


    <el-drawer
      :visible.sync="TopMenu_show"
      direction="ltr"
      :before-close="TopMenuClose"
      custom-class="custom-drawer"
      size="180px"
      
      >
      <span @click="TopMenu_show=false" class="top_menu">
        <!-- <div><router-link to="PageSearchTop"><i class="el-icon-medal-1"></i> <span style="margin-right: 20px;">인기검색순</span></router-link></div> -->
        <!-- <div><router-link to="PageType?type=1"><i class="el-icon-s-ticket"></i> <span style="margin-right: 20px;">영화</span></router-link></div>
        <div><router-link to="PageType?type=2"><i class="el-icon-video-camera-solid"></i> <span style="margin-right: 20px;">드라마</span></router-link></div>
        <div><router-link to="PageType?type=3"><i class="el-icon-s-flag"></i> <span style="margin-right: 20px;">예능</span></router-link></div>
        <div><router-link to="PageType?type=4"><i class="el-icon-s-opportunity"></i> <span style="margin-right: 20px;">시사</span></router-link></div>
        <div><router-link to="PageType?type=5"><i class="el-icon-bicycle"></i> <span style="margin-right: 20px;">애니메이션</span></router-link></div>
        <div><router-link to="PageType?type=6"><i class="el-icon-hot-water"></i> <span style="margin-right: 20px;">OTT예능</span></router-link></div>
        <div><router-link to="PageType?type=9"><i class="el-icon-s-shop"></i> <span style="margin-right: 20px;">지난드라마</span></router-link></div> -->
        
        <!-- <div><a href="https://utt131.com" target="_blank"><i class="el-icon-present"></i> <span style="margin-right: 20px;">릴게임</span></a></div> -->

        <el-menu @select="handleSelect">
            
          <!-- 人气搜索顺序 -->
          <el-menu-item index="92">
            <i class="el-icon-medal-1 el-menu-item-li"></i>
            <!-- <span slot="title" class="menu-font item_span">인기검색순</span> -->
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">인기검색순</span>
          </el-menu-item>
          <!-- 电影 -->
          <el-menu-item index="1">
            <i class="el-icon-s-ticket el-menu-item-li"></i>
            <!-- <span slot="title" class="menu-font item_span">영화</span> -->
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">영화</span>
          </el-menu-item>
          <!-- 电视剧 -->
          <el-menu-item index="2" route="AboutView">
            <i class="el-icon-video-camera-solid el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">드라마</span>
          </el-menu-item>
          <!-- 综艺/娱乐 -->
          <el-menu-item index="3">
            <i class="el-icon-s-flag el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">예능</span>
          </el-menu-item>
          <!-- 综艺/娱乐 -->
          <el-menu-item index="4">
            <i class="el-icon-s-opportunity el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">시사</span>
          </el-menu-item>
          <!-- 时事/教养 -->
          <el-menu-item index="5">
            <i class="el-icon-bicycle el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">애니메이션</span>
          </el-menu-item>
          <!-- YouTube综艺 -->
          <el-menu-item index="6">
            <i class="el-icon-hot-water el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">OTT예능</span>
          </el-menu-item>
          <!-- 完结的电视剧 -->
          <el-menu-item index="9">
            <i class="el-icon-guide el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">지난드라마</span>
          </el-menu-item>
          <!-- 最新更新 -->
          <el-menu-item index="91">
            <i class="el-icon-upload el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">최신업데이트<el-badge v-if="GetInfo.today_count>0" :value="GetInfo.today_count" style="top:-15px;left:-20px;"></el-badge></span>
          </el-menu-item>
          <el-menu-item index="93">
            <i class="el-icon-link el-menu-item-li"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">링크동맹</span>
          </el-menu-item>

          <el-menu-item index="100">
            <!-- <i class="el-icon-present"></i> -->
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">🔞&nbsp;성인</span>
          </el-menu-item>
          <el-menu-item index="101">
            <i class="el-icon-present"></i>
            <span slot="title" class="menu-font item_span" style="color: #ffff00;font-size: 13px;">코믹툰툰</span>
          </el-menu-item>
          <!-- <el-menu-item index="101">
            <span slot="title" class="menu-font item_span" style="color: #ff0000;font-size: 13px;">⚽︎&nbsp;월드컵 경기분석</span>
          </el-menu-item> -->
          
        </el-menu>

      </span>
    </el-drawer>
    
    <el-drawer
      :visible.sync="TopSearch_show"
      direction="ttb"
      :before-close="TopSearchClose"
      custom-class="custom-drawer"
      >
      <span>
        <div>

          <!-- <el-form ref="form" size="mini"> -->
            <el-input maxlength="20" v-model="keys" size="mini" placeholder="띄어쓰기 정확히 입력해주세요">
              <!-- <el-button @click="'PageSearch?keys='+keys" slot="append" icon="el-icon-search"></el-button> -->
              <el-button @click="goTo('/PageSearch?keys='+keys)" slot="append" icon="el-icon-search"></el-button>
            </el-input>  
          <!-- </el-form> -->
        
        </div>
        <div class="top_menu" style="margin-top: 10px;">
          <div @click="TopSearch_show=false" v-for="(item,index) in GetInfo.topkeys" :key="index">

            <router-link :to="'/PageSearch?keys='+item">
              <el-tag type="success"><i class="el-icon-magic-stick" style="cursor: pointer;"></i> {{item}}</el-tag>
            </router-link>

          </div>
        </div>

      </span>
    </el-drawer>

  </div>
  

</template>
<script>
import TopSearch from '@/components/TopSearch.vue'
import TopSearch_m from '@/components/TopSearch_m.vue'

// import HeadNav from '@/components/HeadNav.vue';
import FootNav from '@/components/FootNav.vue';
export default {
  components: {
    // HeadNav,
    TopSearch,
    TopSearch_m,
    FootNav
  },
  metaInfo: {
    // 改变页面标题
    title: '골드티비',
    // 修改 meta 标签
    meta: [
      { charset: 'utf-8' },
      { name: 'keywords', content: '무료다시보기사이트,최신한국영화,드라마,예능,시사,해외영화,드라마,애니메이션,영화순위,드라마순위,누누티비,액션,스릴러,로맨스,공포,링크사이트모음' },
      { hid: 'description', name: 'description', content: '버퍼링 없는 무료다시보기 사이트-최신영화,드라마,예능,시사,애니등 그 이상에 즐거움을  골드티비에서 더 간편하게 온라인에서 재생해보세요' }
    ]
  },
  data() {
    return {
      keys:'',
      screenWidth:0,
      GetInfo:{
        today_count:0,
        topkeys:[],
        article:[],
        hidelink:[],
        img:[],
        link:[]
      },
      gridData: [],
      WidthIsHidden:false,
      TopMenu_show: false,
      TopSearch_show: false,
    };
  },
  created() {
    // document.title = 'The보다';
  },
  mounted() {
    // document.title = 'The보다';

    // const searchParams = new URLSearchParams(window.location.search);

    // this.from = searchParams.get('from')=='1'?'1':'0'

    this.loadPage()

    this.checkWidth();
    window.addEventListener('resize', this.checkWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkWidth);
  },
  methods: {
    loadPage() {
      var this_ = this

      this_.topkeys = []
      this.httpinfo.PostInfo(this,this.baseOther + "disp?type=get_today_count",{
        from:FFom
      }, function(e) {
        if(e.data.code==0){
          
          this_.GetInfo.today_count = e.data.data.today_count
          
          // if(e.data.data.topkeys.code==0){
          //   this_.GetInfo.topkeys = e.data.data.topkeys.data
          // }
          /////////////////////////////////////////
          var tempTopSearch = this_.httpinfo.getData('topsearch')

          if(tempTopSearch==undefined||tempTopSearch=='undefined'){
            tempTopSearch = []
            this_.GetInfo.topkeys = tempTopSearch
          }else{
            this_.GetInfo.topkeys = JSON.parse(tempTopSearch)
          }
          /////////////////////////////////////////



          if(e.data.data.hidelink.code==0){
            this_.GetInfo.hidelink = e.data.data.hidelink.data
          }
          if(e.data.data.link.code==0){
            this_.GetInfo.link = e.data.data.link.data
          }
          if(e.data.data.article.code==0){
            this_.GetInfo.article = e.data.data.article.data
          }
          if(e.data.data.img.code==0){
            this_.GetInfo.img = e.data.data.img.data
          }
          
          if(e.data.data.notice.code==0){
            if(e.data.data.notice.data!==''&&e.data.data.notice.data!==undefined){
              this_.openNotice(e.data.data.notice.data)
            }
          }

        }

      });

      /////////////////////////////////////////
      var tempHistory = this_.httpinfo.getData('history')

      if(tempHistory==undefined||tempHistory=='undefined'){
        tempHistory = []
        this_.gridData = tempHistory
      }else{
        this_.gridData = JSON.parse(tempHistory)
      }
      /////////////////////////////////////////
    },
    checkWidth() {
      this.screenWidth = window.innerWidth
      this.WidthIsHidden = !(window.innerWidth < 768);
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);

      switch(key){
        // case '9'://已完结电视剧
        //   this.goTo('/PageType?type=1-0&page=1')
        //   break
        case '91'://最新更新
          this.goTo('/PageUpdate')
          break
        case '92'://最新更新
          this.goTo('/PageSearchTop')
          break
        case '93'://友情链接
          this.goTo('/PageLink')
          break
        case '100'://广告
          window.open("http://t.me/goldtv9","_blank")
          break
        case '101'://코믹툰툰
          // window.open("https://xn--1-qm2fo90cyvca.com/","_blank")
          window.open("https://comictt7.com/","_blank")
          break
        // case '101'://FIFA
        //   this.goTo('/PageFIFA')
        //   break
        default:
          this.goTo('/PageType?type='+key)
      }
    },
    goTo(path) {

      this.TopSearch_show=false
// console.log("****")
// console.log(this.$router.currentRoute.fullPath)
// console.log("=======")
      if (path !== this.$router.currentRoute.fullPath) {
        // console.log(path)
        this.loading = true
        this.$router.push(path);
      }
    },
    TopMenuClose(done) {
      this.TopMenu_show = false
    },
    showTopMenu(e){
      this.TopMenu_show = e
    },
    TopSearchClose(done) {
      this.TopSearch_show = false
    },
    showTopSearch(e){
      this.TopSearch_show = e
    },
    openNotice(Msg){
      this.$alert(Msg, '공지', {
        confirmButtonText: '닫기',
        callback: action => {

        }
      });
    }
  }
}
</script>
<style>

  body{
    /* background-color: #372C2E;
    color: #FFF; */
    font-size: 14px;
    background-color: #000;
    color: #FFF;
  }



  .menu-font{
    font-weight: bold;font-size: 18px;
    /* color: #FFF; */
  }


  .one_line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-menu-item-li{
    color: #ffd700 !important;
    text-shadow: 5px 5px 10px #ffd700; /* 金色阴影 */
  }

  .item_span{
    line-height: 1.1;
    position: relative;
    z-index: 2;
    flex: 1;
    -webkit-font-smoothing: subpixel-antialiased;
    /* color: #ffd700; */
    /* color: linear-gradient(45deg, #FFD700, #FFA500); */
    /* color: linear-gradient(135deg, #FFD700 0%, #FFA500 100%); */
    /* text-shadow: 2px 2px 4px #ffd700; 金色阴影 */

    background: #ffff00;
    /* background: linear-gradient(to bottom, #ffff00 0%, #ffff00 40%, #8c5c2e 55%, #ffff00 80%, #ffff00 91%); */
    -webkit-background-clip: text;
    /* color: transparent; */
    color: #fff !important;
  }

  .item_span_m{
    line-height: 1.1;
    position: relative;
    z-index: 2;
    flex: 1;
    -webkit-font-smoothing: subpixel-antialiased;
    font-size: 13px;
    /* color: #ffd700; */
    /* color: linear-gradient(45deg, #FFD700, #FFA500); */
    /* color: linear-gradient(135deg, #FFD700 0%, #FFA500 100%); */
    /* text-shadow: 2px 2px 4px #ffd700; 金色阴影 */

    background: #ffff00;
    /* background: linear-gradient(to bottom, #ffff00 0%, #ffff00 40%, #8c5c2e 55%, #ffff00 80%, #ffff00 91%); */
    -webkit-background-clip: text;
    /* color: transparent; */
    color: #fff !important;
  }

  
  /* 注意：垂直模式水平折叠收起菜单后里面item的背景色要在App.vue中设置
  .el-menu {
      background-image: linear-gradient(135deg, #EE9AE5 10%, #5961F9 100%) !important;
  } */

  .el-drawer {
    /* z-index: -3000!important; */
    background: rgba(0,0,0, 1)!important;
    
  }

  ::v-deep.el-drawer__wrapper {
    /* z-index: -3000!important; */
    background: rgba(0,0,0, 0.8);
    
  }

  ::v-deep.el-drawer {
    background: rgba(132, 0, 255, 0.8);
  }

  .el-drawer__header {
    padding: 0 !important;
    /* width: 520px !important; */
    color: #000;
    height: 20px;
    margin: 12px;
    /* background: rgba(0, 0, 0, 0.5) !important; */
  }

  .el-drawer__body {
    margin: 0px 10px 10px 10px;
    /* background: rgba(0,0,0, 0.5) !important; */
    /* padding: 0; */
    /* width: 520px !important; */
    /* height: 340px; */
    position: relative;
  }

  .el-drawer.ttb{
    color: #ffd700;
    background-color: #000;
  }

  .top_menu{
    width: 100%;
  }
  .top_menu div{
    display: inline-block;
    /* float: left; */
    width: auto;
    margin: 5px 5px;
  }

  .crft{
    padding: 20px;
    background-color: #111;
    font-size: 9pt;
    color: rgb(110, 110, 110);
  }
  .crft .rol{
    margin-bottom: 8px;
  }

  .crft .foot_router{
    display: inline; ;padding-right: 5px;
  }
  .crft .foot_router:hover{
    color: #000;
  }
  .crft .foot_img{
    display: inline; ;padding-right: 15px;
  }

    /* 闪烁文字 */
.neon-text {
  animation: rainbow 0.3s infinite;
} 
@keyframes rainbow {
    0% { color: red; }
    17% { color: orange; }
    33% { color: yellow; }
    50% { color: green; }
    67% { color: blue; }
    83% { color: indigo; text-shadow:
      0 0 4px #fff,
      0 0 11px #fff,
      0 0 19px #fff}
    100% { color: violet; }
    
}




/* .neon-text {
  color: #fff; 
  text-shadow:
    0 0 7px #fff, 
    0 0 10px #fff, 
    0 0 21px #fff,
    0 0 42px #0fa,
    0 0 82px #0fa,
    0 0 92px #0fa,
    0 0 102px #0fa,
    0 0 151px #0fa; 
  animation: flicker 1.5s infinite alternate; 
}
@keyframes flicker {
  0%, 19%, 21%, 23%, 25%, 54%, 56%, 100% {
    text-shadow:
      0 0 4px #fff,
      0 0 11px #fff,
      0 0 19px #fff,
      0 0 40px #0fa,
      0 0 80px #0fa,
      0 0 90px #0fa,
      0 0 100px #0fa,
      0 0 150px #0fa;
  }
  20%, 24%, 55% {
    text-shadow: none;
  }
} */
</style>
